import { ref, Ref, watch } from "vue";
import Konva from "konva";
import { getStagePosition, setReactPositionToList } from "./common";

interface BrushOptions {
  mode?: "brush" | "eraser";
  strokeWidth?: Ref<number>;
}

const useBrush = (
  stage: Ref<Konva.Stage | null>,
  layer: Ref<Konva.Layer | null>,
  enable: Ref<boolean>,
  onCreated?: (line: Konva.Shape) => void,
  opt: BrushOptions = {}
) => {
  let isPaint = false;
  let line: Konva.Line;
  const options: BrushOptions = {
    mode: "brush",
    strokeWidth: ref(14),
  };
  const { mode, strokeWidth } = Object.assign(options, opt);
  watch(
    [stage, layer],
    (val) => {
      const [newStage, newLayer] = val;
      if (!newStage || !newLayer) return;
      newStage.on("touchstart", function () {
        if (!enable.value) return;
        isPaint = true;
        const [x, y, scale] = getStagePosition(newStage, strokeWidth!.value);
        line = new Konva.Line({
          stroke: mode === "brush" ? "rgba(255, 255, 255, 0.4)" : "#000",
          strokeWidth: strokeWidth!.value / scale,
          // round cap for smoother lines
          lineCap: "round",
          lineJoin: "round",
          globalCompositeOperation:
            mode === "brush" ? "source-over" : "destination-out",
          // add point twice, so we have some drawings even on a simple click
          points: [x, y, x, y],
          draggable: false,
          tension: 0.5,
        });

        newLayer.add(line);
        if (onCreated) {
          onCreated(line);
        }
      });
      newStage!.on("touchmove", function () {
        if (!isPaint) {
          return;
        }
        const [x, y] = getStagePosition(newStage, strokeWidth!.value);
        const newPoints = line.points().concat([x, y]);
        line.points(newPoints);
      });

      newStage!.on("touchend", function () {
        isPaint = false;
        setReactPositionToList();
      });
    },
    { immediate: true }
  );
};

export default useBrush;
